import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { UpsaleBonusDialogProps } from './UpsaleBonusDialog.types';

export const renderUpsaleBonusModal = (data?: UpsaleBonusDialogProps) =>
    openPopupHelper({ popupName: popupNames.UPSALE_BONUS_MODAL, data });
